/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

window.prettyFileIcons = require('pretty-file-icons');

import Lang from 'lang.js';
Vue.prototype.trans = new Lang({ messages: window.translations, locale: window.default_locale, fallback: window.fallback_locale });

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
    position: 'bottom-center',
    duration: 6000,
    fullWidth: true,
});
// Register the toast with the custom message
Vue.toasted.register('appError',
    (payload) => {

        // If there is no message passed show default message
        if (!payload.message) {
            return 'Oops.. Something Went Wrong..'
        }

        // If there is a message show it with the message
        return `<span>Oops.. ${payload.message}<span>`;
    },
    {
        type: 'error',
    }
)

// Register the toast with the custom message
Vue.toasted.register('appSuccess',
    (payload) => {
        return payload.message;
    },
    {
        type: 'success',
    }
)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// filters
Vue.filter('prettyBytes', require('./shared/pretty-bites.js').default);

// Directives
Vue.directive('can', require('./directives/can.js').default);
Vue.directive('has-error', require('./directives/has-error.vue').default);

// Shared
Vue.component('modal', require('./shared/modal.vue').default);
Vue.component('spinner', require('./shared/spinner.vue').default);
Vue.component('upload', require('./shared/upload.vue').default);
Vue.component('file-manager', require('./shared/file-manager.vue').default);

Vue.component('datatable-paging', require('./shared/datatable/paging.vue').default);
Vue.component('datatable-search', require('./shared/datatable/search.vue').default);
Vue.component('datatable-sort', require('./shared/datatable/sort.vue').default);
Vue.component('datatable-add', require('./shared/datatable/add.vue').default);
Vue.component('datatable-edit', require('./shared/datatable/edit.vue').default);
Vue.component('datatable-delete', require('./shared/datatable/delete.vue').default);
Vue.component('datatable-typeahead', require('./shared/datatable/typeahead.vue').default);

// Components
Vue.component('collections-table', require('./pages/collections/index.vue').default);
Vue.component('collections-edit', require('./pages/collections/edit.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',

    data() {
        return {
            pageSpinner: undefined,
        }
    }
});
